<script type="ts">
	import { onMount } from 'svelte';

	import Button from './Button.svelte';

	import { storeSettings } from '../../store/StoreSettings';
	import { applyColors } from '../../utils';

	export let publicKey: string;
	export let primaryColor: string;
	export let buttonText: string;
	export let membershipCode: string;

	storeSettings.set({
		publicKey: publicKey,
		primaryColor: primaryColor ? `${primaryColor}` : '#e52b51',
		buttonText: buttonText,
		membershipCode: membershipCode
	});

	onMount(() => {
		applyColors({ primary: primaryColor, secondary: null });
	});
</script>

<div class="cobraticket-widget">
	<Button />
</div>

<style global>
	@tailwind base;
	@tailwind components;
	@tailwind utilities;

	@layer utilities {
		input[type='number']::-webkit-inner-spin-button,
		input[type='number']::-webkit-outer-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
	}
</style>
